const bankCodes = {
  BCP: '1',
  BBVA: '2',
  INTERBANK: '3',
  SCOTIABANK: '4',
  OTHERS: 'cci'
} as const

export default bankCodes
